<template>
    <div class="status f-row">
        <div :class="getClass">{{getText}}</div>
    </div>
</template>

<script>
import {mapGetters } from 'vuex';

export default {
    name: "ConnectionState",
    data: function(){
        return {
        }
    },
    methods:{
    },
    computed:{        
        ...mapGetters(['ConnectionState']),   
        getClass(){
            switch(this.ConnectionState) {
                case 0:
                    return 'nok';
                    break;
                case 1:
                    return 'ok';
                    break;
                case 2:
                    return 'warn';
                    break;
                default:
                    return 'ok';
            }
        },
        getText(){
            switch(this.ConnectionState) {
                case 0:
                    return 'SRV';
                    break;
                case 1:
                    return 'OK';
                    break;
                case 2:
                    return 'TAF';
                    break;
                default:
                    return 'OK';
            }
        }
    },
    components: {
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .status {
        display: flex;
        align-items: center;
        margin-right: ($height_default / 2);
        text-align: center;
        line-height: 21px;
        font-weight: bold;
        color:$font-dark-color;
        margin-left: auto; 

        div {
            height: 21px;
            width: $height_mid;
            border-radius: 5px;
        }
    }

    .ok {
        background-color: $prim_success_color;
    }

    .warn {
        background-color: $prim_warning_color;
    }

    .nok {
        background-color: $prim_aleart_color;
    }

    @media screen and (max-width: 400px) {       
        .status {
            margin-right:10px;
        }
    }

</style>